import { useEffect, useState } from 'react';
import { EqCondition, Filter, useFilterContext, ConditionProps } from 'framework/list';
import { FilterCondition } from 'framework/types';
import EmployeeInput, { buildEmployeeAutoSuggestLabel } from 'domain/shared/employee/input/EmployeeInput';
import { InputLoader } from 'framework/ui/mui-builder';
import useEmployeeService from '../employeeService';

const setEmployeeLabel = (searchSuggestions: any, alias: any, setLabel: any, setAliasLoaded: any) => {
  (async () => {
    const response = await searchSuggestions({
      filter: {
        alias: {
          eq: alias,
        },
      },
    });
    const employee = response && response.result && !!response.result.length && response.result[0];
    const employeeLabel = buildEmployeeAutoSuggestLabel(employee);
    setLabel(employeeLabel);
    setAliasLoaded(true);
  })();
};

type EmployeeFilterProps = {
  source: string;
  label: string;
  withContractors?: boolean;
  isVisible?: boolean;
} & Omit<ConditionProps, 'children'>;

const EmployeeFilter = ({ label: filterLabel, source, withContractors = true, ...props }: EmployeeFilterProps) => {
  const { filterBy, getValue } = useFilterContext();
  const { searchSuggestions, searchWithContractors } = useEmployeeService();

  const [label, setLabel] = useState('');
  const [aliasLoaded, setAliasLoaded] = useState(false);

  const searchMethod = withContractors ? searchWithContractors : searchSuggestions;

  useEffect(() => {
    const alias = getValue(source, FilterCondition.EQ);
    if (!alias) {
      setAliasLoaded(true);
    } else {
      setEmployeeLabel(searchMethod, alias, setLabel, setAliasLoaded);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeCallback = (filter: Filter) => {
    filterBy(filter);
  };

  return aliasLoaded ? (
    <EqCondition {...props} source={source} onChangeCallback={onChangeCallback}>
      <EmployeeInput initialLabel={label} source={source} label={filterLabel} withContractors={withContractors} />
    </EqCondition>
  ) : (
    <InputLoader />
  );
};

export default EmployeeFilter;
